import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[13px] ml-[6px] text-left text-[24px] font-bold leading-[160%] tracking-[-0.035em] text-white" }, " 사진 업로드 ", -1)
const _hoisted_2 = { class: "mb-16 flex w-full items-center" }
const _hoisted_3 = { class: "flex-1 text-[14px] font-normal leading-[136%] tracking-[-0.015em] text-white" }
const _hoisted_4 = { class: "flex items-start" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[2px] mb-[6px] flex-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#3FFFA3]" }, "고화질 1인 인물 정면 사진"),
  /*#__PURE__*/_createTextVNode("을 준비해주세요. ")
], -1)
const _hoisted_7 = { class: "flex items-start" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[2px] mb-[6px] flex-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#3FFFA3]" }, "입술은 붉은 계열로 자연스럽게"),
  /*#__PURE__*/_createTextVNode(" 해주세요. ")
], -1)
const _hoisted_10 = { class: "flex items-start" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[2px] mb-[6px] flex-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#3FFFA3]" }, "투명한 배경"),
  /*#__PURE__*/_createTextVNode("은 피해주세요. ")
], -1)
const _hoisted_13 = { class: "flex items-start" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[2px] mb-[14px] flex-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#3FFFA3]" }, "얼굴을 가리는 방해물이 있는 사진"),
  /*#__PURE__*/_createTextVNode("은 피해주세요."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" (선글라스, 앞머리, 머리날림, 마스크, 턱수염 등) ")
], -1)
const _hoisted_16 = { class: "flex items-start" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[2px] mb-[6px] flex-1" }, " 권장 사진 사이즈는 512*512 픽셀이며, jpg, jpeg, png 이미지 파일만 등록 가능합니다. ", -1)
const _hoisted_19 = { class: "flex items-start" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[2px] flex-1" }, " 합성 사진에 타인의 얼굴을 동의없이 활용할 경우, 법적 처벌을 받으실 수 있습니다. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadPicture = _resolveComponent("UploadPicture")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UploadPicture, {
        class: "mr-[25px] h-[250px] w-[250px]",
        onChange: _cache[0] || (_cache[0] = (e) => _ctx.$emit('change', e))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@assets/icons/O.svg'),
            class: "mr-1"
          }, null, 8, _hoisted_5),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: require('@assets/icons/O.svg'),
            class: "mr-1"
          }, null, 8, _hoisted_8),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            src: require('@assets/icons/X.svg'),
            class: "mr-1"
          }, null, 8, _hoisted_11),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            src: require('@assets/icons/X.svg'),
            class: "mr-1"
          }, null, 8, _hoisted_14),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("img", {
            src: require('@assets/icons/Star.svg'),
            class: "mr-1"
          }, null, 8, _hoisted_17),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("img", {
            src: require('@assets/icons/Star.svg'),
            class: "mr-1"
          }, null, 8, _hoisted_20),
          _hoisted_21
        ])
      ])
    ])
  ], 64))
}